<template>
  <div id="index"
       class="animate-in">
    <!--顶部搜索筛选-->
    <div class="row">
      <div class="col-md-12">
        <div class="box fz-content-box">
          <div class="box-body fz-box-body">

            <form class="form-inline searchForm"
                  id="searchForm"
                  action="#"
                  method="GET">
              <div class="form-group mr15"><span class="fz-menu-name">{{menuName}}</span></div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!--数据列表页面-->
    <section class="content">
      <div class="row">
        <div class="col-md-12">
          <div class="box fz-box">
            <div class=" table-responsive">
              <table class="table table-hover fz-table-hover fz-table-bordered datatable"
                     width="100%">
                <thead>
                  <tr class="fz-gray">
                    <th style="width:80px;">信息类型</th>
                    <th style="width:60px;">级别</th>
                    <th style="width:180px;">所属设备</th>
                    <th style="width:120px;">设备名称</th>
                    <th>描述及内容</th>
                    <th style="width:160px;">时间</th>
                  </tr>
                </thead>
                <tbody>

                  <tr v-for="(item,index) in currentList"
                      :key="item.key"
                      :class="[index===1?'active':'']">
                    <td>
                      <span style="margin-right:10px; color:#999;"
                            class="icon-pointer iconfont icon-yidu1 green"
                            v-if="item.read_time"></span>
                      <span style="margin-right:10px;  color:#ff9800; font-size:18px;"
                            class="icon-pointer iconfont icon-weidu green"
                            @click="redMessage(item)"
                            v-if="!item.read_time"></span>
                      <span v-if="item.type==1">报警</span>
                      <span v-if="item.type==2">告警</span>
                    </td>
                    <td>
                      <span v-if="item.level==1">Ⅰ</span>
                      <span v-if="item.level==2">Ⅱ</span>
                      <span v-if="item.level==3">Ⅲ</span>
                    </td>
                    <td>

                      <a href="#"
                         @click="gotostatus(item.device)"> {{item.device.address_sort}}</a>
                    </td>
                    <td>{{item.product_name}}</td>
                    <td>{{item.info}}</td>
                    <td>{{item.send_time }}</td>
                  </tr>

                </tbody>
              </table>
            </div>

          </div>
          <!-- 数据列表底部 -->
          <div class="fz-box-footer center-block text-center">
            <pagination :num="num"
                        :offset="current_page"
                        :limit="limit"
                        @getNew="getNew"></pagination>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import pagination from "@/components/pagination.vue"
import '@/static/plugins/bootstrap-datetimepicker/js/bootstrap-datetimepicker.js';
import '@/static/plugins/bootstrap-datetimepicker/js/locales/bootstrap-datetimepicker.zh-CN.js';
import '@/static/plugins/bootstrap-datetimepicker/css/bootstrap-datetimepicker.css';

import { req, reqFile } from "../../api/axiosFun"

export default {
  name: 'wechatList',
  data () {
    return {
      menuName: "信息列表",
      loading: false, //是显示加载
      startTime: "",
      endTime: "",
      listData: [],
      currentList: [],
      listData: [
      ],
      currentList: [],
      // 分页参数
      num: 0,
      limit: 13, current_page: 1,
      pageparm: {
        currentPage: 1,
        pageSize: 12,
        total: 0
      }
    }
  },
  components: {
    pagination
  },
  created () {

  },
  mounted () {

    this.num = this.listData.length;
    //必须在组件渲染之后调用
    this._dateDefault();
    this.requestData();
  },
  methods: {
    _dateDefault () {
      let _this = this;
      $('#datetimepicker1').datetimepicker({
        language: 'zh-CN',
        format: 'yyyy-mm-dd hh:ii',
        weekStart: 1,

        todayBtn: 1,
        autoclose: 1,
        todayHighlight: 1,
        startView: 2,
        minView: 0,
        maxView: 1,
        forceParse: 0,
      }).on("hide", function (ev) {
        var value = $("#startTime").val();
        _this.startTime = value;
      });

      $('#datetimepicker2').datetimepicker({
        language: 'zh-CN',
        format: 'yyyy-mm-dd hh:ii',
        weekStart: 1,
        todayBtn: 1,
        autoclose: 1,
        todayHighlight: 1,
        startView: 2,
        minView: 0,
        maxView: 1,
        forceParse: 0,
      }).on("hide", function (ev) {
        var value = $("#endTime").val();
        _this.endTime = value;
      });
    },
    async requestData () {
      this.canRefresh = false;
      let res = await req('GET', '/message?page=' + this.current_page + '&limit=' + this.limit + '&k=' + this.searchKey);

      if (res) {
        this.listData = res.data;
        this.currentList = res.data;
        this.next_page = res.current_page >= res.meta.last_page ? res.meta.current_page : res.meta.current_page + 1;
        this.num = res.meta.total;
      }
      this.$parent.isLoading = false;
      this.resload = 10;
      this.canRefresh = true;
    },
    async redMessage (item) {
      this.canRefresh = false;
      let res = await req('POST', '/message/' + item.id, {});

      item.read_time = true;
      vm.$set(this.listData, this.listData.indexOf(item), item)

    },
    gotostatus (item) {
      if (item.product_type == 3) {

        this.$router.push({ path: '/business/status2', query: { id: item.id } });
        return;
      }
      this.$router.push({ path: '/business/status', query: { id: item.id } });
    },

    getNew (page) {


      this.current_page = page ? page / this.limit + 1 : 1;
      this.$router.push({
        path: '/business/message?page=' + this.current_page,
        query: {
          site: [],
          bu: []
        }
      })
      this.requestData();
    },
    toSearch () {
      console.log(this.startTime, this.endTime);
    },
  },
}
</script>
<style lang="scss" scoped>
</style>

